module.exports = __webpack_public_path__ + "static/media/population.c3389ddd.svg";